<!-- Add any extra content that might be supplied with the component -->
<div class="extra-content">
  <ng-content></ng-content>
</div>

<!-- Fixed demo sidebar -->
<treo-vertical-navigation
  [navigation]="menuData"
  [inner]="true"
  [mode]="'side'"
  [name]="'tasks-sidebar-navigation'"
  [opened]="true"
></treo-vertical-navigation>
